import styled from 'styled-components';

const SVGWrapper = styled.div`
  margin: 7.5px 0px 15px 0px;
`;

SVGWrapper.displayName = 'SVGWrapper';

export default SVGWrapper;
